import classnames from "classnames";
import { ROLES } from "lib/role-helpers";

const RoleSplit = (props) => {
  const { className, value, options } = props;
  const roleClassName = classnames("filter-select filter_role-split", className);

  const handleRoleClick = (role) => {
    if (value === role.value) {
      props.onFilterChange("role", { value: ROLES.ALL });
    } else {
      props.onFilterChange("role", role);
    }
  };

  return (
    <div className={roleClassName}>
      {options.map((role) => {
        const optionClassName = classnames({
          "role-option": true,
          active: value === role.value,
        });
        return (
          <div key={role.value} className={optionClassName} onClick={() => handleRoleClick(role)}>
            {role.img}
          </div>
        );
      })}
    </div>
  );
};

export default RoleSplit;
